import React from "react";
import { Grid, Hidden, Select } from "@material-ui/core";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import InputField from "../../components/Field";
import CREATE_CHEF from "../../graphql/mutations/chef/create_chef";
import DinerButton from '../../components/DinerButton';
import { graphql } from "react-apollo";
import { connect } from "react-redux";
import { stateList } from "../../config/constants";
import style from "./style";
import Fab from "@material-ui/core/Fab/Fab";
import { Persist } from "formik-persist";

const LocationSchema = Yup.object().shape({
  street1: Yup.string()
    .matches(/^(?!.*(?:(.*((p|post)[-.\s]*(o|off|office)[-.\s]*(box|bin)[-.\s]*)|.*((p |post)[-.\s]*(box|bin)[-.\s]*)))).*$/i, { message: "Please enter a physical address" })
    .required("Please enter a physical address"),
  /*street2: Yup.string()
        .required('Please enter a valid Apartment/Suite'),*/
  city: Yup.string().matches(/[a-zA-Z]/, { message: "Only letters are allowed" }).required("Please enter a valid city"),
  state: Yup.string().matches(/[A-Z]/, { message: "2 letter state. Eg: CA" }).min(2, "2 letter state. Eg: CA").max(2, "2 letter state. Eg: CA").required("Please enter State"),
  zip: Yup.string()
    .matches(/[0-9]/, { message: "Only numbers are allowed" })
    .min(5, "Zip code should be 5 digits")
    .max(5, "Zip code should be 5 digits")
    .required("Please enter a valid zip code"),
  country: Yup.string().matches(/[A-Z]/, { message: "ex: US" }),
  canFly: Yup.boolean(),
  maxTravelDistance: Yup.number()
});

class Location extends React.Component {
  componentDidMount() {
    window.onload = function() {
      window.scrollTo(0, 0);
    };
  }

  constructor(props) {
    super(props);
    const { data, distance, canFly } = props;

    this.state = {
      distance: distance ? distance : 30,
      canFly: canFly,
      initialState: {
        street1: data && data.street1 ? data.street1 : "",
        street2: data && data.street2 ? data.street2 : "",
        city: data && data.city ? data.city : "",
        state: data && data.state ? data.state : "",
        country: data && data.country ? data.country : "US",
        zip: data && data.zip ? data.zip : "",
        maxTravelDistance: distance,
        canFly: props.canFly
      },
      zipCode: data && data.zip ? data.zip : "",
    };
  }

  handelSliderChange = value => {
    this.setState({ distance: value });
  };
  handleCanFly = value => {
    this.setState({
      canFly: value
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.data !== prevProps.data) {
      let { data, canFly, distance } = this.props;
      let isDistanceChanged = distance === this.state.distance;
      let isCanFly = canFly === this.state.canFly;

      const initialState = {
        street1:
          data && data.street1 ? data.street1 : this.state.initialState.street1,
        street2:
          data && data.street2 ? data.street2 : this.state.initialState.street2,
        city: data && data.city ? data.city : this.state.initialState.city,
        state: data && data.state ? data.state : this.state.initialState.state,
        country: data && data.country ? data.country : "US",
        zip: data && data.zip ? data.zip : this.state.initialState.zip,
        maxTravelDistance: isDistanceChanged ? this.state.distance : distance,
        canFly: isCanFly ? this.state.canFly : canFly
      };
      this.setState({ initialState });
    }
  }

  handleChange = ({ target }) => {
    const { initialState } = this.state;
    initialState[target.name] = target.value;
    if (target.name === "zip") {
      let v = target.value;
      if (v.length > 5) {
        v = v.substr(0, 5);
        initialState[target.name] = v;
      }
    }
    this.setState({ initialState });
  };


  render() {
    let { mutate } = this.props;
    let { initialState, canFly, distance } = this.state;
    const initialValues = initialState;

    return (
      <div className="chef-right-col">
        <div className="header-step-col">
          <p className="located-text" style={style.headerText}>Where are you located?</p>
          <div className="cont-btn">
            <DinerButton />
          </div>
        </div>
        <Formik
          initialValues={initialValues}
          enableReinitialize={true}
          validationSchema={LocationSchema}
          onSubmit={async values => {
            document.getElementById('location-submit').disabled = true;

            this.props.onSubmit(mutate, {
              ...values,
              maxTravelDistance: distance,
              canFly,
            })
          }}
        >
          {({ errors, touched }) => (
            <Form autocomplete="off">
              <Grid container spacing={16} className="become-chef-custom">
                <Grid item md={6} xs={12}>
                  <InputField
                    name={"street1"}
                    placeholder={"Physical address"}
                    error={errors.street1 && touched.street1}
                    errorMessage={errors.street1}
                    label={"STREET ADDRESS"}
                    type={"text"}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputField
                    name={"street2"}
                    placeholder={"Apt 000"}
                    error={errors.street2 && touched.street2}
                    errorMessage={errors.street2}
                    label={"APARTMENT/SUITE ETC."}
                    type={"text"}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputField
                    name={"city"}
                    placeholder={"ex: Los Angeles"}
                    error={errors.city && touched.city}
                    errorMessage={errors.city}
                    label={"CITY"}
                    type={"text"}
                  />
                </Grid>
                <Grid   data-test-id={"state-id"} item md={6} xs={12}>
                  {/*<InputField
                    name={"state"}
                    placeholder={"State"}
                    error={errors.state && touched.state}
                    errorMessage={errors.state}
                    label={"STATE"}
                    type={"text"}
                  />*/}
                  <div style={{
                    paddingTop: 32,
                    paddingBottom: 13
                  }}>
                    <p style={{fontSize: 14, textAlign: 'left', margin: '5px 0px 0px', fontFamily: 'Poppins', fontWeight: '500'}}>STATE</p>
                    <Field
                      name={"state"}
                      render={({ field, form: { handleChange }}) => <Select
                        inputProps={{MenuProps: {disableScrollLock: true}}}
                        data-test-id={"statedropdown-id"}
                        className="mbl-100"
                        native
                        style={{ fontFamily: 'Poppins', maxWidth: 327, overflow: 'hidden' }}
                        {...field}
                        defaultValue={this.state.initialState.state}
                      >
                        <option value={""} style={{ fontFamily: 'Poppins'}}>Select State</option>
                        {stateList.map(st => (
                          <option value={st.id} key={st.id} style={{ fontFamily: 'Poppins'}}>{st.id}</option>
                        ))}
                      </Select>}
                    />
                  </div>
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputField
                    autocomplete={false}
                    name={"zip"}
                    placeholder={"12345"}
                    error={errors.zip && touched.zip}
                    errorMessage={errors.zip}
                    onChange={this.handleChange}
                    label={"ZIPCODE"}
                    type={"text"}
                  />
                </Grid>
                <Grid item md={6} xs={12}>
                  <InputField
                      name={"country"}
                      placeholder={"ex: US"}
                      error={errors.country && touched.country}
                      errorMessage={errors.country}
                      onChange={this.handleChange}
                      label={"COUNTRY"}
                      type={"text"}
                      disabled={true}
                  />
                </Grid>
                {/*<Grid item md={6} xs={12}>
                  <div>
                    <p style={style.labelText}>
                      How far are you willing to travel?
                    </p>
                    <InputField
                      name={"maxTravelDistance"}
                      hideLable
                      error={
                        errors.maxTravelDistance && touched.maxTravelDistance
                      }
                      errorMessage={errors.maxTravelDistance}
                      type={"slider"}
                      filterType={"distance"}
                      onSliderValueChange={this.handelSliderChange}
                      defaultValue={this.state.distance}
                    />
                  </div>
                </Grid>
                <Grid item md={6} />
                <Grid item md={6} xs={12}>
                  <div>
                    <p style={style.labText}>
                      Miles
                    </p>
                  </div>
                </Grid>*/}
               {/* <Grid item md={6} />
                <Grid item md={6} xs={12}>
                  <InputField
                    name={"canFly"}
                    hideLabel
                    placeholder={"Are You Willing To Fly?"}
                    error={errors.canFly && touched.canFly}
                    errorMessage={errors.canFly}
                    label={"Are you willing to fly?"}
                    type={"checkbox"}
                    checked={this.state.canFly}
                    handleCheckbox={() => this.handleCanFly(!this.state.canFly)}
                  />
                </Grid>*/}
                <Grid
                  container
                  alignItems="flex-end"
                  justify="flex-end"
                  direction="row"
                  style={{marginTop:15}}
                >
                  <Hidden smUp>
                    <Grid item xs={2} />
                    <Grid item xs={8}>
                      <Fab
                         data-test-id={"locsubmit"}
                         id={"location-submit"}
                        variant={"extended"}
                        disabled={this.props.loading}
                        type="submit"
                        style={
                          this.props.loading
                            ? style.submitButtonDisabled
                            : style.submitButton
                        }
                      >
                        Continue
                      </Fab>
                    </Grid>
                  </Hidden>
                  <Hidden xsDown>
                    <Grid item md={12} style={{ textAlign: "right" }}>
                      <Fab
                        id={"location-submit"}
                       data-test-id={"locsubmit"}
                        variant={"extended"}
                        disabled={this.props.loading}
                        type="submit"
                        style={
                          this.props.loading
                            ? style.submitButtonDisabled
                            : style.submitButton
                        }
                      >
                        Continue
                      </Fab>
                    </Grid>
                  </Hidden>
                </Grid>
              </Grid>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

const LocationWithData = graphql(CREATE_CHEF)(Location);
const mapStateToProps = state => {
  return {
    userId: state.auth.userId
  };
};

const LocationContainer = connect(mapStateToProps)(LocationWithData);

export default LocationContainer;
